module.exports = "<div class=\"container-fluid\">\n        <div *ngIf=\"isLoggedIn\">\n                <app-navbar></app-navbar>\n        </div>\n        <div *ngIf=\"!isLoggedIn\">\n                        <app-privatenav></app-privatenav>\n                </div>\n        <router-outlet></router-outlet>\n        <app-footer></app-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main